module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/cover-2-1aa620fa76eef87d0e05cbcbde52a47f.webp";